import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const TYPES = ["info", "warning"];

const Hint = (props) => {
  const { children, className, type, ...rest } = props;

  const componentClass = classnames("sal-hint", `sal-hint-${type}`, className);

  return (
    <div className={componentClass} {...rest}>
      {children}
    </div>
  );
};

Hint.propTypes = {
  type: PropTypes.oneOf(TYPES).isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default Hint;
